import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import useAuthUser from "../hooks/useAuthUser";

export default function History() {
  const userData = useAuthUser();
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!userData?.userDisplayName) return;

    const q = query(
      collection(db, "Market_History"),
      where("historyRecipient", "==", userData.userDisplayName),
      orderBy("historyTimestamp", "desc"),
      limit(50)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setHistory(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    return () => unsubscribe();
  }, [userData?.userDisplayName]);

  const formatUTCDate = (ms) => {
    if (!ms) return "";
    const d = new Date(ms);
    
    return `${String(d.getUTCMonth() + 1).padStart(2, "0")}/${String(d.getUTCDate()).padStart(2, "0")} ${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")}`;
  };

  return (
    <div className="history-container" style={{ 
      padding: "10px", 
      fontFamily: "'JetBrains Mono', monospace", 
      fontSize: "0.7rem",
      height: "90%",
      overflowY: "auto"
    }}>
      {history.length === 0 ? (
        <p style={{ color: "#555" }}>NO HISTORY FOUND</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          {history.map((item) => (
            <div
              key={item.id}
              className="history-entry"
              style={{
                display: "flex",
                gap: "10px",
                padding: "4px 8px",
                borderLeft: "2px solid rgba(80, 227, 194, 0.2)",
                background: "rgba(255, 255, 255, 0.02)",
                transition: "all 0.2s ease",
                alignItems: "flex-start"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(80, 227, 194, 0.05)";
                e.currentTarget.style.borderLeftColor = "#50e3c2";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.02)";
                e.currentTarget.style.borderLeftColor = "rgba(80, 227, 194, 0.2)";
              }}
            >
              <span style={{ 
                color: "#888", 
                whiteSpace: "nowrap", 
                userSelect: "none",
                fontSize: "0.65rem" 
              }}>
                [{formatUTCDate(item.historyTimestamp)}]
              </span>
              
              <span style={{ color: "#50e3c2", userSelect: "none" }}>&gt;</span>
              
              <span style={{ 
                color: "#eee", 
                lineHeight: "1.4",
                wordBreak: "break-word" 
              }}>
                {item.historyMessage}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}